import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../shared/store';

export interface ResendActionsState {
  usersResendList: string[];
  adminResendList: string[];
  internalAdminResendList: string[];
}

const initialState: ResendActionsState = {
  usersResendList: [],
  adminResendList: [],
  internalAdminResendList: [],
};

export const resendSlice = createSlice({
  name: 'resend',
  initialState,
  reducers: {
    addInternalAdminResend: (state, { payload }) => {
      state.internalAdminResendList.push(payload);
    },
    addAdminResend: (state, { payload }) => {
      state.adminResendList.push(payload);
    },
    addUsersResend: (state, { payload }) => {
      state.usersResendList.push(payload);
    },
  },
});

export const { addInternalAdminResend, addAdminResend, addUsersResend } =
  resendSlice.actions;
export const adminResendList = (state: RootState) =>
  state.resendList.adminResendList;
export const usersResendList = (state: RootState) =>
  state.resendList.usersResendList;
export const internalAdminResendList = (state: RootState) =>
  state.resendList.internalAdminResendList;
